import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { AccountHeader } from '@/components/account-nav'
import { Button } from '@/components/ui/button'
import { ApiError, postResetRequest } from '@/lib/kwykedit-api'

export const Route = createFileRoute('/routes/forgot')({
  component: ForgotPage,
})

const inputClassName =
  'w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:border-ring focus:outline-none'

function ForgotPage() {
  const [email, setEmail] = useState('')
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [sent, setSent] = useState(false)

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    if (pending) return
    setPending(true)
    setError(null)
    void postResetRequest(email.trim())
      .then(() => setSent(true))
      .catch((err: unknown) => {
        setError(err instanceof ApiError ? err.message : 'Could not send the reset email.')
      })
      .finally(() => setPending(false))
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <AccountHeader />
      <div className="mx-auto max-w-md px-6 py-12">
        <h1 className="mb-2 text-2xl font-bold">Forgot your password?</h1>
        <p className="mb-6 text-sm text-muted-foreground">
          Enter your account email and we will send a one-time reset link (valid 1 hour).
        </p>
        <div className="rounded-xl border border-border bg-card p-6">
          {sent ? (
            <p className="text-sm">
              If that email has an account, a reset link is on its way. Check your inbox
              (and spam).
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <label className="block text-xs text-muted-foreground">
                Email
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  className={`mt-1 ${inputClassName}`}
                />
              </label>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" disabled={pending} className="w-full">
                {pending ? 'Sending…' : 'Send reset link'}
              </Button>
            </form>
          )}
        </div>
        <p className="mt-4 text-center text-xs text-muted-foreground">
          <Link to="/login" className="underline hover:opacity-80">
            ← Back to log in
          </Link>
        </p>
      </div>
    </div>
  )
}
